"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PermissionTypes_1 = require("../../../DataStores/Permissions/PermissionTypes");
var PermissionsCard_1 = require("Common/ShareResourceComponent/PermissionsCard/PermissionsCard");
var PendingUserPermissionsCard_1 = require("Common/Permissions/PendingUserPermissionsCard/PendingUserPermissionsCard");
var InvitePermissionsCard_1 = require("./InvitePermissionsCard");
var Types_1 = require("@CommonFrontendBackend/Permissions/Types");
var AddCommentSuggestion = function (_a) {
    var suggestion = _a.suggestion, pagePermissionsStore = _a.pagePermissionsStore;
    var suggestionMeta = getSuggestionMetaFromSuggestion(suggestion, pagePermissionsStore);
    if (suggestionMeta.isPending) {
        return renderPendingSuggestion(suggestionMeta, checkNeedsInvite(suggestionMeta));
    }
    else {
        return renderSuggestion(suggestionMeta, checkNeedsInvite(suggestionMeta));
    }
};
var getSuggestionMetaFromSuggestion = function (suggestion, pagePermissionsStore) {
    var user = getUserFromPermissions(suggestion.id, pagePermissionsStore.permittedUsers) ||
        getUserFromPermissions(suggestion.id, pagePermissionsStore.unpermittedUsers);
    if (!user) {
        throw new Error("Couldn't find a user from that suggestion");
    }
    switch (user.type) {
        case PermissionTypes_1.UserType.Existing:
            return {
                email: user.email,
                permission: user.permission,
                name: {
                    firstName: user.firstName,
                    lastName: user.lastName,
                },
                role: user.role,
                isPending: false,
            };
        case PermissionTypes_1.UserType.Pending:
            return {
                email: user.email,
                name: {
                    firstName: user.email,
                },
                role: user.role,
                permission: user.permission,
                isPending: true,
            };
        default:
            throw new Error("Unknown UserPermissionType: ".concat(JSON.stringify(user)));
    }
};
var getUserFromPermissions = function (suggestedId, permissionList) {
    return permissionList.find(function (u) { return u.id === suggestedId.toString(); });
};
var checkNeedsInvite = function (suggestionMeta) {
    var permission = suggestionMeta.permission, role = suggestionMeta.role;
    return role !== Types_1.Role.Admin && (permission === Types_1.Action.None || permission === Types_1.Action.View);
};
var renderSuggestion = function (_a, needsInvite) {
    var name = _a.name, email = _a.email;
    if (needsInvite) {
        return react_1.default.createElement(InvitePermissionsCard_1.InvitePermissionsCard, { email: email, firstName: name.firstName, lastName: name.lastName });
    }
    else {
        return react_1.default.createElement(PermissionsCard_1.UserPermissionsCard, { email: email, firstName: name.firstName, lastName: name.lastName });
    }
};
var renderPendingSuggestion = function (_a, needsInvite) {
    var email = _a.email;
    if (needsInvite) {
        return react_1.default.createElement(InvitePermissionsCard_1.InvitePendingPermissionsCard, { email: email });
    }
    else {
        return react_1.default.createElement(PendingUserPermissionsCard_1.PendingUserPermissionsCard, { email: email, permissionsDropdown: false });
    }
};
exports.default = AddCommentSuggestion;
